import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';
import { Building2, Home, FileSpreadsheet, Package, LayoutDashboard, ArrowRight, ClipboardList } from 'lucide-react';
import { Button } from '@/components/ui/button';
import Dashboard from './Dashboard';
import Materials from './Materials';
import Projects from './Projects';
import ProjectDetails from './ProjectDetails';
import UserGuide from './UserGuide';
import AccountingItems from './AccountingItems';

function BuildingsHome() {
  const navigate = useNavigate();
  
  const quickActions = [
    { icon: LayoutDashboard, label: 'لوحة التحكم', path: '/buildings/dashboard', color: 'from-purple-500 to-violet-600', desc: 'نظرة عامة على جميع المشاريع' },
    { icon: Package, label: 'المواد الأساسية', path: '/buildings/materials', color: 'from-blue-500 to-indigo-600', desc: 'إدارة قائمة المواد والتصنيفات' },
    { icon: Building2, label: 'المشاريع', path: '/buildings/projects', color: 'from-amber-500 to-orange-600', desc: 'إدارة مشاريع العمائر' },
    { icon: ClipboardList, label: 'أصناف البرنامج المحاسبي', path: '/buildings/accounting-items', color: 'from-cyan-500 to-blue-600', desc: 'قائمة أصناف مرجعية من البرنامج المحاسبي' },
    { icon: FileSpreadsheet, label: 'دليل المواد', path: '/buildings/guide', color: 'from-emerald-500 to-teal-600', desc: 'دليل شامل لحساب كميات المواد' },
  ];

  return (
    <div className="min-h-screen">
      {/* Header */}
      <div className="text-center mb-8">
        <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-br from-purple-500 to-violet-600 rounded-2xl shadow-lg mb-4">
          <Building2 className="w-8 h-8 text-white" />
        </div>
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-2">
          نظام إدارة كميات العمائر السكنية
        </h1>
        <p className="text-gray-500 max-w-xl mx-auto">
          نظام متكامل لحساب وإدارة كميات المشاريع الإنشائية للعمائر السكنية الكبيرة
        </p>
      </div>

      {/* Quick Actions */}
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 max-w-5xl mx-auto">
        {quickActions.map((action) => (
          <button
            key={action.path}
            onClick={() => navigate(action.path)}
            className="group p-5 bg-white rounded-xl shadow-md hover:shadow-lg transition-all duration-300 border border-gray-100 text-right"
          >
            <div className={`w-12 h-12 bg-gradient-to-br ${action.color} rounded-xl flex items-center justify-center mb-3 group-hover:scale-110 transition-transform`}>
              <action.icon className="w-6 h-6 text-white" />
            </div>
            <h3 className="font-bold text-gray-800 mb-1">{action.label}</h3>
            <p className="text-xs text-gray-500">{action.desc}</p>
          </button>
        ))}
      </div>

      {/* Back to main */}
      <div className="text-center mt-8">
        <Button onClick={() => navigate('/')} variant="outline" className="gap-2">
          <ArrowRight className="w-4 h-4" />
          العودة للصفحة الرئيسية
        </Button>
      </div>
    </div>
  );
}

export default function BuildingsApp() {
  return (
    <Routes>
      <Route path="/" element={<BuildingsHome />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/materials" element={<Materials />} />
      <Route path="/projects" element={<Projects />} />
      <Route path="/projects/:id" element={<ProjectDetails />} />
      <Route path="/accounting-items" element={<AccountingItems />} />
      <Route path="/guide" element={<UserGuide />} />
    </Routes>
  );
}
